export default __webpack_public_path__ + "static/media/parallaxDifferent2.697a2099.svg";